import toast from '@/common/toast';
import auth from '@/common/auth/auth';

/**
 * Security Guard for authorization and permissions used by the router.
 */
export default class SecurityGuard {
    store = null;

    constructor(store) {
        this.store = store;
    }

    /**
     * Check whether the destination route requires authorization via JWT.
     * @param {RouteConfig} to
     * @returns {boolean}
     */
    static requiresAuthorization(to) {
        return to.meta.authorized === true;
    }

    static isAuthorized({name}) {
        return auth.$pages[name].isAllowed;
    }

    get isLoggedIn() {
        return !this.store.getters['user/isGuest'] && !this.store.getters['user/isSessionExpired'];
    }

    /**
     * Generate the middleware that will process each route and
     * verify whether the user is authenticated and has the correct
     * permissions when required. The route's meta information is used
     * for these checks.
     * @returns {Function}
     */
    get middleware() {
        return (to, from, next) => {
            if (SecurityGuard.requiresAuthorization(to)) {
                if (this.isLoggedIn) {
                    if (SecurityGuard.isAuthorized(to)) {
                        // allow user to proceed to the page
                        next();
                    } else {
                        // when the user lacks authorization we
                        // redirect him to the dashboard
                        toast.negative('You do not have access to this page. Please contact your account administrator if you think this is an error.');
                        next({name: 'dashboard'});
                    }
                } else {
                    // we redirect the user to the login page
                    next({name: 'login'});
                }
            } else if (this.isLoggedIn && !['logout', 'impersonate'].includes(to.name)) {
                // user is logged in but trying
                // to access a guest page that is
                // not the logout we redirect to dashboard
                next({name: 'dashboard'});
            } else {
                // the user can view his intended page
                next();
            }
        };
    }
}
